export default function MySQL_CURRENT_USER() {
  return (
    <div>
      <h2>MySQL_CURRENT_USER</h2>    </div>
  );
}